import { Editor } from '@tiptap/core';
import type { AxiosRequestConfig } from 'axios';
import type { XhrRequestOptions } from '@wix/da-http-client';
import { getFakeResponse } from '@wix/da-http-client/pkg/base';
import { requestPuppyAsync } from '@wix/da-http-client/pkg/async';

/**
 * Sends a request to puppy without us having to interface with redux. Only use this if your extension
 * is unable to use redux-saga based networking. e.g. the Mention plugin
 */
export async function requestPuppyFromExtension(
  editor: Editor,
  options: XhrRequestOptions,
  fakeResponse: (requestOptions: AxiosRequestConfig) => any,
  papiBase?: string
) {
  const csrfToken = editor.storage['da-csrf-token'];

  // We'll let the extension code do any `awaits`, so just returning the promises as-is.
  if (editor.storage['da-fake-api-requests']) {
    return getFakeResponse(fakeResponse(options));
  }

  return requestPuppyAsync(options, { csrfToken }, papiBase);
}
